import React, {Component} from 'react';
import AuthService from '../../services/authService';
import '../Register/register.scss';
import './profile.scss';
import axios from 'axios';
import Nav from '../Nav';

import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Profile extends Component {

    constructor() {
        super();
        this.state = {
            checkText: '',
            color: 'red',
            firstName: '',
            lastName: '',
            email: '',
            showMenu: false,
        }
        this.config = {
            headers: {'Authorization': "bearer " + AuthService.getToken()}
        };
        this.profileUpdate = () => toast.success("Your profile has been updated!", {containerId: 'profileUpdate'});
        this.passwordSuccess = () => toast.success("Your password has been updated!", {containerId: 'passwordSuccess'});
        this.passwordFail = () => toast.error("Your passwords do not match", {containerId: 'passwordFail'});

    }

    componentDidMount() {
        this.getUserData()
    }

    componentWillMount() {
        if (AuthService.loggedIn())
            this.props.history.replace('/profile');
    }

    async getUserData() {
        //on mount
        let user = JSON.parse(AuthService.getUser());
        this.setState({
            firstName: user.first_name,
            lastName: user.last_name,
            email: user.email,
        });
    }

    changeProfileInfo(event) {
        event.preventDefault();
        // console.log("event form", event.currentTarget);
        let first_name = document.getElementById("first-name").value;
        let last_name = document.getElementById("last-name").value;
        let email = document.getElementById("new-email").value;
        if (first_name === "") {
            first_name = this.state.firstName
        }
        if (last_name === "") {
            last_name = this.state.lastName
        }
        if (email === "") {
            email = this.state.email
        }
        let profileObj = {
            first_name,
            last_name,
            email,
        };
        this.sendProfileData(profileObj);
    }

    async sendProfileData(registerObj) {
        let dataURL = " https://onamfc.com/api/";
        await axios.post(dataURL + "user/profile", registerObj, this.config).then(res => {
            // set the new user in the local storage
            AuthService.setUser(res.data)

            // TODO: add a toast message  - Your profile has been updated!
            this.profileUpdate()
        });
    }


    changePassword(event) {
        event.preventDefault();
        // console.log("event form", event.currentTarget);
        let newPassword = document.getElementById("new-password").value;
        let confirmedPassword = document.getElementById("confirm-password").value;
        // check to see if they match
        if (newPassword !== confirmedPassword) {
            // let checkText = document.getElementById("check-text");
            // this.setState({
            //     checkText: "Your passwords do not match",
            // })
            console.log("Password fail")
            this.passwordFail();
            return;
        }
        let passwordObj = {
            password: newPassword,
            password_confirmation: confirmedPassword,
        };
        this.sendPasswordData(passwordObj);
    }

    async sendPasswordData(registerObj) {
        let dataURL = " https://onamfc.com/api/";
        await axios.put(dataURL + "user/pwd", registerObj, this.config).then(res => {
            // Do this after receiving the response
            // reset the input boxes
            this.setState({
                checkText: ''
            })


            document.getElementById("cdp-form").reset();

            // TODO: add a toast message  - Your password has been updated!
            this.passwordSuccess();
        });
    }

    handleClick = () => {
        this.setState({
            showMenu: !this.state.showMenu
        })
    }

    handleClose = (e) => {
        if (e === undefined) {
            if (this.state.showMenu) {
                this.setState({
                    showMenu: false
                })
            }
            return;
        }
        // console.log("close triggered", e.target);
        let target = e.target;

        if (target.classList.contains('large-text') || target.classList.contains('menu-list') || target.classList.contains('small-text') || target.classList.contains('social-icon') || target.classList.contains('menu-slideout') || target.classList.contains('menu-button')) {
            return;
        }

        // if (target.classList.contains('close-menu')){
        if (this.state.showMenu) {
            this.setState({
                showMenu: false
            })
        }
        // }

    }


    render() {
        return (

            <div id="profile-page" onClick={this.handleClose}>
                <Nav showMenu={this.state.showMenu} handleClick={this.handleClick} handleClose={this.handleClose}/>
                <div className="container">

                    <div id="profile-form-container" className="profile">

                        <h3>CHANGE PROFILE INFORMATION</h3>
                        <div id="profile-form">
                            <form onSubmit={this.changeProfileInfo.bind(this)}>
                                <div className="form__field">
                                    <label>First Name</label>
                                    <input id="first-name" type="text" name="first-name"
                                           placeholder={this.state.firstName}/>
                                </div>
                                <div className="form__field">
                                    <label>Last Name</label>
                                    <input id="last-name" type="text" name="last-name"
                                           placeholder={this.state.lastName}/>
                                </div>
                                <div className="form__field">
                                    <label>Email Address</label>
                                    <input id="new-email" type="text" name="email" placeholder={this.state.email}/>
                                </div>
                                <button type="submit" className="yellow-btn profile-form-btn">Update Profile
                                </button>
                            </form>
                            <ToastContainer enableMultiContainer containerId={'profileUpdate'} position={toast.POSITION.TOP_RIGHT} />

                        </div>

                        <h3>CHANGE PASSWORD</h3>
                        <div id="change-password-form">
                            <form onSubmit={this.changePassword.bind(this)} id="cdp-form">
                                <div className="form__field">
                                    <label>New Password</label>
                                    <input id="new-password" type="password" name="new-password"/>
                                </div>
                                <div className="form__field">
                                    <label>Confirm Password</label>
                                    <input id="confirm-password" type="password" name="confirm-password"/>
                                </div>
                                {
                                    this.state.checkText &&
                                    <div id="check-text">
                                        {this.state.checkText}
                                    </div>
                                }


                                <button type="submit" className="yellow-btn profile-form-btn">Update Password
                                </button>
                            </form>
                            <ToastContainer enableMultiContainer containerId={'passwordSuccess'} position={toast.POSITION.TOP_RIGHT} />
                            <ToastContainer enableMultiContainer containerId={'passwordFail'} position={toast.POSITION.TOP_RIGHT} />
                        </div>
                    </div>

                    <div className="view-progress-container">
                        <a className="button ghost-button" href="/progress">View Course Progress</a>
                    </div>
                </div>
            </div>


        )

    }


}

export default Profile;
